import styled, { css } from 'styled-components';
import {
  mq,
  px2rem,
  borderClipPath,
  getTextType,
  getSpace,
  hideVisually
} from '../../../stylesheets/tools';

const StyledTokenInput = styled.div`
  position: relative;
  height: auto;
  ${getTextType('subline')}
  text-transform: uppercase;
  display: flex;
  flex-direction: column;

  ${mq('m')} {
    font-size: ${px2rem('20px')};
  }

  .tokenInput__instructions {
    margin: 10px;
    text-transform: uppercase;
  }

  .tokenInput__container {
    width: 100%;
    height: 100%;
    position: relative;

    ${props =>
      props.theme.siteTheme &&
      !props.insideNavigation &&
      css`
        ${borderClipPath(props.theme.siteTheme.secondary, props.theme.siteTheme.secondary)}
      `}

    ${props =>
      props.insideNavigation &&
      css`
        ${borderClipPath('#000', '#262626')}
      `}
  }

  input {
    position: relative;
    padding: ${getSpace('m')} ${getSpace('xxs')} ${getSpace('xxs')} ${getSpace('xxs')};
    z-index: 1;
    width: 100%;
    background: none;
    margin: 0;
    border: none;
    outline: 0;

    overflow: scroll;
    white-space: nowrap;

    &::-ms-clear {
      display: none;
    }

    &::placeholder {
      text-transform: uppercase;
      font-style: italic;
      color: #000;
      opacity: 1;
    }

    ${props =>
      props.insideNavigation &&
      css`
        color: #fff;

        &::placeholder {
          color: rgba(255, 255, 255, 0.3);
        }
      `}
  }

  .tokenInput__label {
    ${hideVisually()}
  }
`;

export default StyledTokenInput;
